<div class="full-width-panel" [class]="{'warning': hasIssue, 'no-warning': !hasIssue}">
  <app-list-grid-client-side
    [colDefs]="$any(columnDefs)"
    [rowData]="rowData"
    [rowClassRules]="rowClassRules"
    [statusBar]="statusBar"
    [paginationPageSize]="paginationPageSize"
    [suppressCellFocus]="true"
    [suppressRowClickSelection]="true"
    [defaultExcelExportParams]="excelExportParams"
    [defaultCsvExportParams]="csvExportParams"
    (gridReady)="onGridReady($event)"
  />
</div>
